import { FlexRow, FlexColumn } from '@editor/components/utilities/layouts';
import { useWorkspacesFeatureEnabled } from '@editor/global/growthbookUtils';
import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui-kit/themeStyle';

import type { NextChargeData } from '../hooks/types';

/**
 * Payment clarification component to show the seats and total amount for the next charge
 * @param nextCharge - The next charge data
 * @returns The payment clarification component
 */
export const PaymentClarification: React.FC<{
  nextCharge: NextChargeData | null;
}> = ({ nextCharge }) => {
  const isWorkspaceEnabled = useWorkspacesFeatureEnabled();
  if (!nextCharge?.seats || !isWorkspaceEnabled) {
    return null;
  }

  return (
    <FlexRow
      gap={themeStyle.spacing4}
      justifyContent="space-between"
      style={{
        padding: `${themeStyle.spacing16} 0`,
        borderTop: `1px solid ${themeStyle.colorBorder}`,
        borderBottom: `1px solid ${themeStyle.colorBorder}`,
      }}
    >
      <FlexColumn gap={themeStyle.spacing4}>
        <H6>{nextCharge.seats.amount} Editors</H6>
        <H6>{nextCharge.seats.clarification}</H6>
      </FlexColumn>
      <FlexColumn>
        <H6>{nextCharge.seats.total}</H6>
      </FlexColumn>
    </FlexRow>
  );
};
